import makeMoment from '../common/moment/MomentFactory';

function restrictDateRangePicker(pickerExtended) {
  const twoDaysPast = makeMoment().add(-2, 'day');
  const sevenDaysAhead = makeMoment().add(7, 'day').set({ hour: 23, minute: 59, second: 59 });
  const datepicker = pickerExtended.getDatepicker();
  datepicker.rangePickMode = true;
  datepicker.singleDatePicker = false;
  datepicker.readOnly = true;
  pickerExtended.setRangePickMode(true);
  datepicker.maxDate = sevenDaysAhead;
  datepicker.setStartDate(twoDaysPast);
  datepicker.setEndDate(sevenDaysAhead);
  datepicker.updateView();
}

function restrictPeriodSelection(periodSelection) {
  periodSelection.removePeriodHighlighting();
  periodSelection.highlightPeriod('custom');
  periodSelection.disableAllPeriods();
}

function removeDateRangePickerRestrictions(datePickerExtended) {
  const datepicker = datePickerExtended.getDatepicker();
  datepicker.maxDate = makeMoment();
  datepicker.setEndDate(datepicker.endDate);
  datepicker.readOnly = false;
  datepicker.updateView();
}

export default {
  applyRestrictions(datePickerExtended, periodSelection) {
    restrictDateRangePicker(datePickerExtended);
    restrictPeriodSelection(periodSelection);
  },
  removeRestrictions(datePickerExtended) {
    removeDateRangePickerRestrictions(datePickerExtended);
  },
};
